import { render, staticRenderFns } from "./Programm.vue?vue&type=template&id=74e427b2&"
import script from "./Programm.vue?vue&type=script&lang=js&"
export * from "./Programm.vue?vue&type=script&lang=js&"
import style0 from "./Programm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports